import React from 'react';
import styled from 'styled-components';
import {DiffRecord} from './DiffRecord';
import {DiffMap} from './DiffMap';
import {DiffField} from './DiffField';
import {FieldOutputProps} from '../../field/DetailsFieldValue';
import {Schema} from '../../types/Schema';
import {ResourceDetails} from '../../types/ResourceDetails';

type Props = FieldOutputProps & {
  schema: Schema;
  fields: DiffField[];
  diff: DiffMap;
  oldData: ResourceDetails;
  newData: ResourceDetails;
};

export const DiffRecords: React.FC<Props> = (props) => {
  return (
    <Container>
      {props.fields.map((field) => (
        <DiffRecord
          {...props}
          diffField={field}
          diff={props.diff[field.dispValueId || field.id]}
        />
      ))}
    </Container>
  );
};

const Container = styled.tbody``;
